<template>
  <div class="swiper-content center">
    <el-carousel
      :height="imgSize"
      :interval="4000"
      :autoplay="false"
      id="model-relic-swiper"
      :class="{ 'big-center': !visibleSize }"
      :loop="false"
    >
      <el-carousel-item v-for="(item, index) in photos" :key="index">
        <el-image class="swiper-img" :src="item" fit="fill"></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: {
    photos: {
      type: Array,
      default: () => []
    },
    visibleSize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgSize: '370px'
    };
  },
  watch: {
    visibleSize(newValue) {
      this.imgSize = newValue ? '370px' : '50vh';
    }
  }
};
</script>

<style lang="scss">
.swiper-content {
  // width: 100%;
  height: 90vh;
}
#model-relic-swiper {
  width: 80vw;
  height: inherit;
}
.big-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.el-carousel__mask {
  opacity: 0 !important;
}
// .el-carousel__item h3 {
//   color: #475669;
//   font-size: 14px;
//   opacity: 0.75;
//   line-height: 200px;
//   margin: 0;
// }

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }

// .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }
@media screen and (max-width: 960px) {
  #model-relic-swiper {
    width: 100vw;
    height: inherit;
  }
}
</style>
